import { type SVGProps, type Ref, forwardRef, useId } from 'react'

import { cn } from '~/utils/classnames'

export const Slider = forwardRef(
  (
    { className, ...props }: SVGProps<SVGSVGElement>,
    ref: Ref<SVGSVGElement>
  ) => {
    const clip0 = useId()
    const clip1 = useId()
    const filter0 = useId()
    const filter1 = useId()
    const filter2 = useId()
    const filter3 = useId()
    const filter4 = useId()
    const filter5 = useId()
    const paint0 = useId()
    const paint1 = useId()
    const paint2 = useId()
    const paint3 = useId()
    const pattern0 = useId()
    const pattern1 = useId()
    const image0 = useId()

    return (
      <svg
        width="93"
        height="64"
        viewBox="0 0 93 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        ref={ref}
        className={cn('text-foreground', className)}
        {...props}
      >
        <g clipPath={`url(#${clip0})`}>
          <g opacity="0.64">
            <g filter={`url(#${filter0})`}>
              <path
                d="M22.0081 24.8036C-0.71678 24.8036 -9.00008 -1.83333 -8.00008 -10.5L69.2931 -14C76.9598 -7 87.6931 12 69.2931 32C46.2931 57 38.6877 24.8036 22.0081 24.8036Z"
                fill={`url(#${paint0})`}
              />
            </g>
            <g opacity="0.4" filter={`url(#${filter1})`}>
              <path
                d="M1.01717 39.1734C-7.72936 47.2692 -22.7492 32.5043 -29.1658 24.1099L7.94123 -17.6791C19.3006 -16.6162 42.789 -6.93334 45.8672 23.2952C49.715 61.0808 11.9503 29.0536 1.01717 39.1734Z"
                fill={`url(#${paint1})`}
              />
              <path
                d="M1.01717 39.1734C-7.72936 47.2692 -22.7492 32.5043 -29.1658 24.1099L7.94123 -17.6791C19.3006 -16.6162 42.789 -6.93334 45.8672 23.2952C49.715 61.0808 11.9503 29.0536 1.01717 39.1734Z"
                stroke="currentColor"
              />
            </g>
            <g opacity="0.3" filter={`url(#${filter2})`}>
              <path
                d="M60.4808 62.1798C72.7202 59.6262 76.4126 72.2226 76.7289 78.8401L20.3057 94.0822C11.4068 90.5407 -2.47001 78.7838 13.2134 60.0885C32.8176 36.7193 45.1817 65.3717 60.4808 62.1798Z"
                fill="currentColor"
              />
              <path
                d="M60.4808 62.1798C72.7202 59.6262 76.4126 72.2226 76.7289 78.8401L20.3057 94.0822C11.4068 90.5407 -2.47001 78.7838 13.2134 60.0885C32.8176 36.7193 45.1817 65.3717 60.4808 62.1798Z"
                stroke="currentColor"
              />
            </g>
          </g>
          <rect
            x="-298"
            y="-290"
            width="678"
            height="678"
            fill={`url(#${pattern0})`}
            style={{ mixBlendMode: 'soft-light' }}
          />
        </g>
        <g clipPath={`url(#${clip1})`}>
          <g opacity="0.64">
            <g filter={`url(#${filter3})`}>
              <path
                d="M63.2669 25.5331C40.542 25.5331 32.2587 -1.10384 33.2587 -9.77051L110.552 -13.2705C118.219 -6.27051 128.952 12.7295 110.552 32.7295C87.5519 57.7295 79.9465 25.5331 63.2669 25.5331Z"
                fill={`url(#${paint2})`}
              />
            </g>
            <g opacity="0.3" filter={`url(#${filter4})`}>
              <path
                d="M42.276 39.9029C33.5294 47.9987 18.5096 33.2338 12.093 24.8394L49.2 -16.9496C60.5594 -15.8867 84.0478 -6.20385 87.126 24.0246C90.9738 61.8103 53.2091 29.7831 42.276 39.9029Z"
                fill={`url(#${paint3})`}
              />
              <path
                d="M42.276 39.9029C33.5294 47.9987 18.5096 33.2338 12.093 24.8394L49.2 -16.9496C60.5594 -15.8867 84.0478 -6.20385 87.126 24.0246C90.9738 61.8103 53.2091 29.7831 42.276 39.9029Z"
                stroke="currentColor"
              />
            </g>
            <g opacity="0.3" filter={`url(#${filter5})`}>
              <path
                d="M101.74 62.9093C113.979 60.3557 117.671 72.9521 117.988 79.5695L61.5645 94.8117C52.6656 91.2702 38.7888 79.5133 54.4721 60.818C74.0764 37.4487 86.4404 66.1012 101.74 62.9093Z"
                fill="currentColor"
              />
              <path
                d="M101.74 62.9093C113.979 60.3557 117.671 72.9521 117.988 79.5695L61.5645 94.8117C52.6656 91.2702 38.7888 79.5133 54.4721 60.818C74.0764 37.4487 86.4404 66.1012 101.74 62.9093Z"
                stroke="currentColor"
              />
            </g>
          </g>
          <rect
            x="-256.741"
            y="-289.271"
            width="678"
            height="678"
            fill={`url(#${pattern1})`}
            style={{ mixBlendMode: 'soft-light' }}
          />
        </g>
        <rect
          opacity="0.24"
          x="82.5999"
          y="0.5"
          width="8.99999"
          height="63"
          rx="4.49999"
          stroke="currentColor"
          strokeLinecap="round"
          strokeDasharray="4 4"
        />
        <defs>
          <filter
            id={filter0}
            x="-18.5801"
            y="-24.5"
            width="108.533"
            height="76.5098"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="5.25"
              result="effect1_foregroundBlur_2278_11933"
            />
          </filter>
          <filter
            id={filter1}
            x="-43.0132"
            y="-31.4005"
            width="102.854"
            height="87.3945"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="6.6"
              result="effect1_foregroundBlur_2278_11933"
            />
          </filter>
          <filter
            id={filter2}
            x="-7.5977"
            y="37.1352"
            width="98.0453"
            height="70.6731"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="6.6"
              result="effect1_foregroundBlur_2278_11933"
            />
          </filter>
          <pattern
            id={pattern0}
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          >
            <use xlinkHref={`#${image0}`} transform="scale(0.000488281)" />
          </pattern>
          <filter
            id={filter3}
            x="22.6787"
            y="-23.7705"
            width="108.533"
            height="76.5098"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="5.25"
              result="effect1_foregroundBlur_2278_11933"
            />
          </filter>
          <filter
            id={filter4}
            x="-1.75444"
            y="-30.671"
            width="102.854"
            height="87.3945"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="6.6"
              result="effect1_foregroundBlur_2278_11933"
            />
          </filter>
          <filter
            id={filter5}
            x="33.6611"
            y="37.8647"
            width="98.0453"
            height="70.6731"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="6.6"
              result="effect1_foregroundBlur_2278_11933"
            />
          </filter>
          <pattern
            id={pattern1}
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          >
            <use xlinkHref={`#${image0}`} transform="scale(0.000488281)" />
          </pattern>
          <radialGradient
            id={paint0}
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(54.1371 38.6257) rotate(-134.594) scale(49.9617 127.05)"
          >
            <stop stopColor="currentColor" />
            <stop offset="1" stopColor="currentColor" stopOpacity="0.44" />
          </radialGradient>
          <linearGradient
            id={paint1}
            x1="35.1638"
            y1="15.2902"
            x2="4.91934"
            y2="54.3941"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.474545" stopColor="currentColor" />
            <stop offset="1" stopColor="currentColor" stopOpacity="0" />
          </linearGradient>
          <radialGradient
            id={paint2}
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(95.3959 39.3552) rotate(-137.127) scale(46.4807 118.198)"
          >
            <stop stopColor="currentColor" />
            <stop offset="1" stopColor="currentColor" stopOpacity="0.44" />
          </radialGradient>
          <linearGradient
            id={paint3}
            x1="76.4226"
            y1="16.0197"
            x2="46.1781"
            y2="55.1236"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.474545" stopColor="currentColor" />
            <stop offset="1" stopColor="currentColor" stopOpacity="0" />
          </linearGradient>
          <clipPath id={clip0}>
            <rect width="63.9999" height="64" rx="8" fill="white" />
          </clipPath>
          <clipPath id={clip1}>
            <rect x="68.7998" width="9" height="64" rx="4.5" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )
  }
)

Slider.displayName = 'SliderEmptyState'
